import React from "react";
import BookingDetails from "./BookingDetails/BookingDetails";

export const MachineryBreakdownProrata = () => {
  return (
    <>
      <BookingDetails premiumType="MACHINERY_BREAKDOWN_PRORATA" />
    </>
  );
};
